import { createContext } from 'react';

/** Undefined is a standalone editor; null is a closed card; an element hosts its disclosed controls. */
export const FieldCardSettingsContext = createContext<HTMLElement | null | undefined>(undefined);
